module.exports = __webpack_public_path__ + "static/media/40.875c02ec.mp3";